import { connect } from 'react-redux'

import { withData, withStateMappedToProps, CATALOG, IS_AUTHENTICATED, SUBSCRIPTIONS, USAGE_PLANS } from '../../redux/withData'

import TheComponent from './ApiHeader.js';

const requiredData = [CATALOG, IS_AUTHENTICATED, SUBSCRIPTIONS, USAGE_PLANS]

const mapStateToProps = state => {
  return withStateMappedToProps(state, requiredData)
}

const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(withData(requiredData)(TheComponent))